import React, { useEffect, useState } from 'react';
import * as API from 'api';
import { useQuery } from 'react-query';
import { withStyles } from '@material-ui/core/styles';
import MuiGrid from '@material-ui/core/Grid';
import MuiBox from '@material-ui/core/Box';
import MuiTextField from '@material-ui/core/TextField';
import MuiInputAdornment from '@material-ui/core/InputAdornment';
import MuiSearchIcon from '@material-ui/icons/Search';

import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTablePagination from '@material-ui/core/TablePagination';
import Row from './ReviewSplitRow';
const styles = () => ({
  container: {
    marginTop: '2rem',
  },
  bold: {
    fontWeight: 'bold',
  },
});

const Track = API.Tracks();
const ROWS_PER_PAGE = 5;
function ReviewSplits({ classes, trackIds, formData, updateForm }) {
  const [tracks, setTracks] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTracks, setFilteredTracks] = useState(tracks);
  const [allPassthroughs, setAllPassthoughs] = useState([]);

  const [tablePage, setTablePage] = useState(0);
  const { isLoading } = useQuery(['track', [...trackIds]], () => Track.getFromList(trackIds), {
    onSuccess: tracksArrays => {
      const allTracks = tracksArrays.flat();
      setTracks(allTracks);
      setFilteredTracks(allTracks);
      const _allPassthroughs = allTracks.map(track => ({
        trackId: track.id,
        passThroughSplitIds: track.stakeholderTrackSplits
          ?.filter(s => s.recoupAccountPassthroughs.length > 0)
          .map(s => s.id),
      }));
      setAllPassthoughs(_allPassthroughs);
      //go ahead and put them in the form as well
      updateForm({ target: { id: 'passThroughs', value: _allPassthroughs } });
    },
  });

  useEffect(() => {
    if (searchTerm) {
      // Matches by beggining of a word against title, party names or isrc
      const filterRegExString = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const matcher = new RegExp(`\\b${filterRegExString}`, 'gi');

      const newFilteredTracks = tracks.filter(currentTrack => {
        const titleMatches = currentTrack.title.match(matcher);
        const partiesMatch = currentTrack.trackParties
          .filter(tp => tp.roles.includes('MainArtist'))
          .map(tp => tp.party.full_name)
          .join(' ')
          .match(matcher);
        const isrcMatch = currentTrack.isrc_code.match(matcher);

        return titleMatches || partiesMatch || isrcMatch;
      });

      setFilteredTracks(newFilteredTracks);
    } else {
      setFilteredTracks(tracks);
    }
  }, [searchTerm, setFilteredTracks]);

  function updateTrackPasthroughs(trackPassThroughs) {
    //Update the form here with the track passthoughs
    updateForm({
      target: {
        id: 'passThroughs',
        value: [...formData.passThroughs.filter(p => p.trackId !== trackPassThroughs.trackId), trackPassThroughs],
      },
    });
  }

  return (
    <MuiGrid container className={classes.container}>
      <MuiGrid item xs={3}>
        <span className={classes.bold}>Review Splits</span>
        <p>If any passthroughs are needed for specific tracks, please add them here.</p>
      </MuiGrid>
      <MuiGrid item xs={6}>
        <MuiBox>
          <div className={classes.actionRow}>
            <MuiTextField
              variant="outlined"
              label="Filter tracks"
              placeholder="Filter tracks"
              onChange={e => {
                e.preventDefault();
                setSearchTerm(e.target.value);
              }}
              value={searchTerm}
              InputProps={{
                startAdornment: (
                  <MuiInputAdornment position="start">
                    <MuiSearchIcon />
                  </MuiInputAdornment>
                ),
              }}
            />
          </div>
        </MuiBox>
        <MuiBox>
          <MuiTableContainer>
            <MuiTable>
              <MuiTableBody>
                {/* slice args come from material-ui docs/example for paginated tables: https://github.com/mui-org/material-ui/blob/0979e6a54ba47c278d1f535953c0520a86349811/docs/src/pages/components/tables/CustomPaginationActionsTable.js#L122 */}
                {filteredTracks
                  .slice(tablePage * ROWS_PER_PAGE, tablePage * ROWS_PER_PAGE + ROWS_PER_PAGE)
                  .map(currentTrack => (
                    <Row
                      key={currentTrack.id}
                      track={currentTrack}
                      updateTrackPasthroughs={updateTrackPasthroughs}
                      currentPassthroughs={
                        allPassthroughs.find(p => p.trackId === currentTrack.id)?.passThroughSplitIds
                      }
                    />
                  ))}
                <MuiTableRow>
                  <MuiTablePagination
                    rowsPerPageOptions={[]}
                    rowsPerPage={ROWS_PER_PAGE}
                    count={tracks?.length || 0}
                    page={tablePage}
                    onPageChange={(event, page) => setTablePage(page)}
                  />
                </MuiTableRow>
              </MuiTableBody>
            </MuiTable>
          </MuiTableContainer>
        </MuiBox>
      </MuiGrid>
    </MuiGrid>
  );
}

export default withStyles(styles)(ReviewSplits);
